import type { RefObject } from 'react'
import { useCallback } from 'react'

export interface UseNotificationKeyboardOptions {
  notificationCount: number
  focusedIndex: number
  setFocusedIndex: (index: number) => void
  itemRefs: RefObject<(HTMLDivElement | null)[]>
}

export const useNotificationKeyboard = ({
  notificationCount,
  focusedIndex,
  setFocusedIndex,
  itemRefs,
}: UseNotificationKeyboardOptions): ((event: React.KeyboardEvent) => void) => {
  return useCallback(
    (event: React.KeyboardEvent) => {
      if (notificationCount === 0) return

      if (event.key === 'ArrowDown') {
        event.preventDefault()
        const nextIndex = focusedIndex < notificationCount - 1 ? focusedIndex + 1 : 0
        setFocusedIndex(nextIndex)
        itemRefs.current?.[nextIndex]?.focus()
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault()
        const prevIndex = focusedIndex > 0 ? focusedIndex - 1 : notificationCount - 1
        setFocusedIndex(prevIndex)
        itemRefs.current?.[prevIndex]?.focus()
      }
    },
    [focusedIndex, notificationCount, setFocusedIndex, itemRefs]
  )
}
